import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setReturnShippingPaid } from "../lib/draft.lib";

export function useSetReturnShippingPaid(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  return (returnShippingPaid: boolean) => {
    setDraft((prev) =>
      prev ? setReturnShippingPaid(prev, returnShippingPaid) : prev,
    );
  };
}
